<template>

  <div class="left_side_item pt-2 d-flex flex-column">
    <div class="d-flex flex-column">

      <div style="height: 34px;font-size: 14px;" class="d-flex gap-2 pb-2 border-bottom ">

        <div  class="d-flex gap-1 align-items-center">
          <img style="height: 24px" src="/svgs/search.svg" alt="">
          <input type="text" class="h-100 form-control" placeholder="ძებნა" v-model="this.search" >
        </div>

        <div class="d-flex gap-1 align-items-center">
          <img style="height: 23px" src="/svgs/filter.svg" alt="">
          <select @change="updateSelectedView(selectedView)" class="h-100" v-model="this.selectedView" name="view">
            <option value="1">საწყობები</option>
            <option value="2">მოწყობილობები</option>
          </select>
        </div>

        <OnClickOutside @trigger="()=>{this.dropdownOpen = false}">
          <div class="dropdown" @click="toggleDropdown" style="position: relative">
          <button class="btn btn-link" style="padding: 0 !important;">
            <img style="height: 24px; rotate: 90deg" src="/svgs/arrows.svg" alt="">
          </button>

          <div
              v-if="dropdownOpen"
              class="dropdown-menu d-flex flex-column show"
              style="display: flex !important; position: absolute; z-index: 1000;"
          >
            <a
                v-for="(option, index) in orderOptions"
                :key="index"
                class="dropdown-item d-flex gap-2 justify-content-between"
                href="#"
                @click.prevent="setOrder(option.value)"
            >
              <div class="d-flex gap-2">
                <span>{{ option.label }}</span>
              </div>

              <img
                  class="order-icon"
                  style="width: 14px;"
                  :style="{ rotate: isAsc ? '-90deg' : '90deg' }"
                  src="/svgs/arrow.svg"
                  alt=""
                  v-if="currentOrder === option.value"
                  @click.stop="toggleDirection"
              />
            </a>
          </div>
        </div>
        </OnClickOutside>

      </div>
    </div>

    <div class="content-slots px-2" v-if="this.selectedView == 1 && !loading && filteredWarehouses && filteredWarehouses.length">
      <template v-for="warehouse in filteredWarehouses" :key="warehouse">
        <div :class="'d-flex align-items-start justify-content-between warehouse-item ' + isActiveRoom(warehouse.id,'warehouse')" @click="fetchRoomSensors(warehouse.warehouse_rooms.map((item) =>  item.id))">
          {{warehouse.name}}

          <!-- maybe collapse here -->
        </div>
        <div class="d-flex flex-column align-items-end justify-content-start room-slots" v-if="warehouse.warehouse_rooms && warehouse.warehouse_rooms.length">
          <div class="d-flex flex-column align-items-end justify-content-start room-wrapper sub_main_section">
            <template v-for="room in warehouse.warehouse_rooms" :key="room.id">
              <div  :class="'p-0 d-flex align-items-center justify-content-between room-item ' + isActiveRoom(room.id)" >

                <div @click="fetchRoomSensors(room.id)" class="p-2 w-100 d-flex align-items-center justify-content-between " >
                  {{room.name}}
                  <div style="width: 75px" class="d-flex justify-content-between sensor-data font-roboto">
                    <img src="/svgs/temp-green.svg" alt=""> {{ room.avgTempo == 0 ? '00.0 ℃' : room.avgTempo.toFixed(1) + ' ℃'}}
                  </div>
                </div>

                <div class="tooltip-wrapper" @click="showTooltip(room)" >
                  <img src="/svgs/dots.svg" alt="" ref="tooltip" >
                  <OnClickOutside @trigger="tooltipOutsideClick">
                    <div :class="isEditingRoom && room.id === this.$parent.lastOpenedRoom.id ? 'opened ' : '' " class="tooltip">
                      <div class="tooltip-content d-flex justify-content-around" data-bs-toggle="modal" data-bs-target="#exampleModal">
                        <img src="/svgs/pencil.svg" alt="">
                      </div>
                    </div>
                  </OnClickOutside>
                </div>

              </div>
            </template>
          </div>
        </div>
      </template>
    </div>

    <div class="content-slots px-2" v-if="this.selectedView == 2 && !loading && controllers && controllers.length">
      <template v-for="controller in controllers" :key="controller.imei">
        <div :class="'d-flex align-items-start justify-content-between warehouse-item ' + isActiveRoom(controller.warehouse_id,'warehouse') + (lastTransmissions[controller.imei] && lastTransmissions[controller.imei].datestamploc <= 0.1 ? ' bg-online ' : '')" @click="fetchRoomSensors(controller.warehouse_rooms)">
          <span>
            {{controller.name}}
          </span>
          <div class="d-flex gap-2 align-items-center justify-content-center " style="height: 21px">
            <span v-if="lastTransmissions[controller.imei] && lastTransmissions[controller.imei].datestamploc > 0.1" class="lineh-100" title="კონტროლერის ბოლო გადმოცემა"
                    :class="Helper.measureString(lastTransmissions[controller.imei].datestamploc).color" >
              {{ Helper.measureString(lastTransmissions[controller.imei].datestamploc).finalString }}
            </span>

            <div class="edit-btn" @click="showControllerNameEditTooltip(controller)" data-bs-toggle="modal" data-bs-target="#ControllerNameEditModal" >
              <img src="/svgs/pencil.svg" alt="">
            </div>
          </div>

        </div>
        <div style="background-color: #f8f9fb" class="pt-2 px-3 d-flex flex-wrap gap-2">
          <div v-for="sensor in controller.sensors" class="d-flex gap-1 align-items-center sensor-data" data-toggle="tooltip" :title="(sensor.index + 1) + ' სენსორი' ">
            <div  style="font-size: 12px" class="d-flex gap-1 font-roboto text-nowrap align-items-center">
              <img style="height: 12px" src="/svgs/temp-green.svg" alt="">
              <span>
                {{sensor.tempo ? Number(sensor.tempo).toFixed(1) + ' ℃' : '--' }}
              </span>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>

  <ControllerNameEditModal/>

</template>

<script>
import {useRoute} from "vue-router";
import { OnClickOutside } from '@vueuse/components'
import Helper from "../../helpers/Helper";
import ControllerNameEditModal from "@/components/partials/reusable/ControllerNameEditModal.vue";

export default {
  name: 'LeftSideITem',
  components:{ControllerNameEditModal, OnClickOutside},
  computed: {
    Helper() {
      return Helper
    },
    warehouses(){
      return this.$store.state.warehouse ? this.$store.state.warehouse.list.data : null
    },
    controllers() {
      const warehouse = this.filteredWarehouses;
      if (!warehouse) return null;
      const search = this.search

      return warehouse.flatMap(item =>
          item.controllers.map(controller => ({
            ...controller,
            name: item.name,
            warehouse_id: item.id,
            warehouse_rooms: item.warehouse_rooms.map((item) =>  item.id),
            sensors: item.warehouse_rooms.flatMap(room => room.sensors)
                .filter(sensor => sensor.imei === controller.imei)
          })).filter(controller => {
            if (search === '') return true
            return controller.name.toLowerCase().includes(search.toLowerCase())
          })
      );
    },
    filteredWarehouses() {
      let list = this.$store.state.warehouse.list.data?.list || [];

      if (this.search) {
        list = list.filter(item =>
            item.name.toLowerCase().includes(this.search.toLowerCase())
        );
      }

      list = list.slice(); // avoid mutating original

      if (this.currentOrder === 'name') {
        const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
        list.sort((a, b) =>
            this.isAsc
                ? collator.compare(a.name, b.name)
                : collator.compare(b.name, a.name)
        );
      } else if (this.currentOrder === 'lastTransmission') {
        list.sort((a, b) => {
          const aTime = this.lastTransmissions[a.controllers?.[0]?.imei]?.datestamploc || 100000000000000;
          const bTime = this.lastTransmissions[b.controllers?.[0]?.imei]?.datestamploc || 100000000000000;
          return this.isAsc
              ? aTime - bTime
              : bTime - aTime;
        });
      }

      return list;
    },
    lastTransmissions() {
      return this.$store.state.warehouse.lastTransmissions;
    }
  },
  methods:{
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
      localStorage.setItem('isAsc', this.isAsc);
    },
    setOrder(value) {
      if (this.currentOrder === value) {
        this.isAsc = !this.isAsc;
      } else {
        this.currentOrder = value;
        this.isAsc = true;
      }

      localStorage.setItem('currentOrder', this.currentOrder);
      localStorage.setItem('isAsc', this.isAsc);

      this.dropdownOpen = false;
    },
    toggleDirection() {
      this.isAsc = !this.isAsc;
    },
    showControllerNameEditTooltipOutsideClick() {
      this.isEditingController = false
    },
    showControllerNameEditTooltip(controller) {
      this.selectedController = controller
      this.isEditingController = !this.isEditingController
    },
    startPolling() {
      const poll = async () => {
        try {
          clearTimeout(this.polling);
          await this.$store.dispatch('warehouse/getAllLastTransmissions');
        } catch (err) {
        } finally {
          this.polling = setTimeout(poll, 1000 * 60 * 2); // adjust interval as needed
        }
      };
      poll();
    },
    stopPolling() {
      clearTimeout(this.polling);
      this.polling = null;
    },
    updateSelectedView(value) {
      this.selectedView = value;
      localStorage.setItem('selectedView', value);
    },
    fetchRoomSensors(roomId) {
      this.activeRoomId = roomId;
      localStorage.setItem('activeRoomId', JSON.stringify(roomId)); // <-- Save to localStorage

      this.$store.dispatch('warehouse/getWarehouseRoomSensors', this.activeRoomId).then(() => {
        let warehouse = this.warehouses.list.filter(
            item => item.warehouse_rooms.filter(r => {
              if (Array.isArray(this.activeRoomId)) {
                this.$parent.activeToggle = "table";
                return r.id === parseInt(this.activeRoomId[0]);
              }
              return r.id === this.activeRoomId;
            }).length > 0
        );

        if (Array.isArray(this.activeRoomId)) {
          this.$parent.lastOpened = {
            warehouse: warehouse[0],
            activeRoom: null,
            roomSelected: false,
          };
        } else {
          warehouse = warehouse[0];
          this.$parent.lastOpened = {
            warehouse: warehouse,
            activeRoom: warehouse.warehouse_rooms.filter(item => item.id === this.activeRoomId)[0],
            roomSelected: true,
          };
          this.$parent.fetchSensorPins();
        }

        // Switch to sensors tab on mobile when either a warehouse or room is selected
        if (window.innerWidth < 768 && this.$parent.mobileTab) {
          this.$parent.mobileTab = 'sensors';
        }
      });
    },
    isActiveRoom(roomId, type = 'room'){
      // Don't auto-select rooms from a method that's called during rendering
      // This should be handled in mounted() instead

      if (type === "warehouse" && Array.isArray(this.activeRoomId)){
        let rms = this.warehouses.list.filter(item => item.id === roomId)[0]
        let findedRoom = rms.warehouse_rooms.filter(it => it.id === this.activeRoomId[0])
        if (findedRoom.length > 0){
          return 'active-room'
        }
      }

      if (this.activeRoomId === roomId){
        return 'active-room'
      }
    },
    showTooltip(room){


      // if (this.$parent.lastOpenedRoom === null || this.$parent.lastOpenedRoom.id !== room.id ){
        this.$parent.lastOpenedRoom = room
        this.isEditingRoom = !this.isEditingRoom
      // }else{
      //   this.$parent.lastOpenedRoom = null
      //   this.isEditingRoom = false
      // }
    },
    tooltipOutsideClick(){
      this.isEditingRoom = false
    }
  },
  watch: {
    selectedView(newVal) {
      if (newVal == 2) {
        this.startPolling();
      } else {
        this.stopPolling();
      }
    }
  },
  data(){
    return {
      dropdownOpen: false,
      currentOrder: localStorage.getItem('currentOrder') || 'name',
      isAsc: localStorage.getItem('isAsc') !== 'false',
      orderOptions: [
        { label: 'სახელი', value: 'name' },
        { label: 'ბოლო გადმოცემა', value: 'lastTransmission' },
      ],
      loading: true,
      activeRoomId: 0,
      isEditingRoom: false,
      isEditingController: false,
      selectedController: null,
      selectedView: localStorage.getItem('selectedView') ? parseInt(localStorage.getItem('selectedView')) : 1,
      search: '',
      polling: null,
    }
  },
  beforeDestroy() {
    this.stopPolling();
  },
  mounted() {
    if (this.selectedView === 2) {
      this.startPolling();
    }

    this.$store.dispatch('warehouse/getWarehouseList').then(() => {
      this.loading = false;

      let savedRoomId = localStorage.getItem('activeRoomId');

      //check if saved room id belongs to any warehouse
      if (savedRoomId) {
        let parsedRoomId = JSON.parse(savedRoomId);
        if (Array.isArray(parsedRoomId)) {
          parsedRoomId = parsedRoomId[0]
        }

        const warehouse = this.warehouses.list.filter(item => item.warehouse_rooms.filter(r => r.id === parsedRoomId).length > 0);
        if (warehouse.length === 0) {
          localStorage.removeItem('activeRoomId');
          savedRoomId = null;
        }
      }

      if (savedRoomId) {
        const parsedRoomId = JSON.parse(savedRoomId);
        // Don't auto-fetch on mobile if we're viewing the warehouses tab
        const isMobile = window.innerWidth < 768;
        const isWarehouseTab = this.$parent && this.$parent.mobileTab === 'warehouses';
        
        if (!isMobile || !isWarehouseTab) {
          this.fetchRoomSensors(parsedRoomId);
        }
      } else if (!window.innerWidth || window.innerWidth >= 768) {
        // Only auto-select first room on desktop, not on mobile
        let rms = this.warehouses.list.filter(item => item.warehouse_rooms.length > 0)
        if (rms.length > 0) {
          this.fetchRoomSensors(rms[0].warehouse_rooms[0].id)
        }
      }

      setTimeout(() => {
        const el = document.querySelector('.active-room');
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);

    });

    const route = useRoute();
    if (route.params.roomId) {
      this.fetchRoomSensors(Array.isArray(route.params.roomId) ? route.params.roomId : parseInt(route.params.roomId));
    }
  }
}
</script>

<style scoped>

select {
  border: 1px #dee4ed solid;
  background: none;
  border-radius: 5px;
  padding: 0 5px;
}

.warehouse-item{
  border: 1px solid var(--border-color);
  width:100%;
  border-radius: 5px;
  padding: 4px 8px;
  margin-top:8px;
  font-size: 14px;
  color: var(--main-bg);
}

.room-slots{
  margin-top: 10px;
}

.room-wrapper{
  width: 95%;
}

.room-item{
  width: 95%;
  border-radius: 5px;
  padding: 8px;
  margin-top:5px;
  font-size: 14px;
}


.room-item:hover, .warehouse-item:hover{
  background-color: var(--hover-item);
  cursor: pointer;
}

.room-item.active-room, .warehouse-item.active-room{
  cursor: pointer;
  border: 1px solid var(--label-color);
}

.sensor-data{
  position: relative;
  font-size: 14px;
  font-family: var(--bs-body-font-family)
}

.sensor-data img {
  height: 20px;
}

.tooltip-wrapper{
  position:relative;

}

.tooltip{
  opacity: 0;
  display: none;
  position: absolute;
  background: #FFFFFF;
  /*left: 70%;*/
  top:30px;
  padding: 10px;
  box-shadow: 5px 0 10px 0 rgba(0, 0, 0, 0.1);
  max-width: 300px;
  border-radius: 5px;
}
.tooltip.opened{
  opacity: 1;
  display: block;
}
.tooltip-content{
  padding:5px;
}

.tooltip-content img{
  margin-right: 10px;
  width:15px;
}

.tooltip .tooltip-content::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 15%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #FFFFFF transparent;
}

.tooltip-content:hover{
  background-color: var(--hover-item);
  border-radius: 5px;
}

@media only screen and (min-width: 1198px) and (max-width: 1679px) {
  .room-item{
    font-size:12px;
  }

  .tooltip{
    font-size: 12px;
  }
}

.content-slots {
  margin-top: 10px;
  flex: .97;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin; /* Firefox */
  scrollbar-color: rgba(0, 0, 0, 0.3) transparent; /* Firefox */
}
.warehouse-item {
  & .edit-btn {
    display: none;
  }
  &:hover {
    & .edit-btn {
      display: block;
    }
  }
}

.lineh-100 {
  line-height: 100%;
}

</style>